import { render, staticRenderFns } from "./ProjectSummaryPostCrowdfunding.vue?vue&type=template&id=bed2453c"
import script from "./ProjectSummaryPostCrowdfunding.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryPostCrowdfunding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports